import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { DateRange, MultiSelect } from '@user/components/Filters'
import { soldServiceStatusText } from '@user/components/SoldServices/utils/soldServiceStatusText'
import { useSaveOpportunityFilters } from '@user/store/opportunity'
import { defaultFilters as defaultOppFilters } from '@user/store/opportunity/filters'
import { produce } from 'immer'
import { useCallback } from 'react'

export const useSetOppSoldServicesStatusFilter = () => {
  const saveOpportunityFilters = useSaveOpportunityFilters()

  const setFilter = useCallback(
    (
      status: SOLD_SERVICE_STATUS,
      salesFunnelId?: MultiSelect,
      salesFunnelName?: string,
      salesTeamId?: MultiSelect,
      createdDate?: DateRange,
      ownerId?: MultiSelect,
      type?: MultiSelect,
    ) => {
      if (status) {
        saveOpportunityFilters(
          produce(defaultOppFilters, (draft) => {
            draft.filters.closed.value = 'empty'
            draft.filters.soldServiceStatus.value = {
              mode: 'any',
              options: [
                { label: soldServiceStatusText(status), value: status },
              ],
            }
            draft.filters.salesFunnelId.value =
              salesFunnelId && salesFunnelName
                ? {
                    mode: 'any',
                    options: salesFunnelId.options,
                  }
                : defaultOppFilters.filters.salesFunnelId.value
            draft.filters.salesTeamId.value = salesTeamId
              ? {
                  mode: salesTeamId.mode,
                  options: salesTeamId.options,
                }
              : defaultOppFilters.filters.salesTeamId.value

            draft.filters.expectedClosingDate.value = createdDate
              ? {
                  matchType: createdDate.matchType,
                  start: createdDate.start,
                  end: createdDate.end,
                }
              : defaultOppFilters.filters.expectedClosingDate.value

            draft.filters.closedDate.value = createdDate
              ? {
                  matchType: createdDate.matchType,
                  start: createdDate.start,
                  end: createdDate.end,
                }
              : defaultOppFilters.filters.closedDate.value

            draft.filters.assignee.value = ownerId
              ? {
                  mode: ownerId.mode,
                  options: ownerId.options,
                }
              : defaultOppFilters.filters.assignee.value

            draft.filters.type.value = type
              ? {
                  mode: type.mode,
                  options: type.options,
                }
              : defaultOppFilters.filters.type.value
          }),
        )
      }
    },
    [saveOpportunityFilters],
  )

  return [setFilter] as const
}
